<template>
  <div class="fiche-societe">

    <main class="fiche-societe__main">

  <!-- LOADING -->
  <transition
    leave-active-class="d-none"
  >
    <div
      v-if="fetchState.status.value === 'pending'"
      class="fiche-client-tab__loading"
    >
      <ui-spinner
        :type="UI.SPINNER_TYPE.BORDER"
        :size="UI.SIZE.MEDIUM"
        class="color-gray-90 mx-auto my-3"
      />
    </div>
  </transition>
  <!-- LOADING -->

  <!-- ERROR MISC -->
  <transition
    enter-active-class="animate__animated animate__fadeIn ease-in-out a3"
  >
    <div
      v-if="fetchState.status.value === 'error'"
      class="fiche-client-tab__error"
    >
      Erreur de chargement de la fiche client
    </div>
  </transition>
  <!-- ERROR MISC -->

  <transition
    enter-active-class="animate__animated animate__fadeIn ease-in-out a6"
  >
    <div
      v-if="fetchState.status.value === 'success'"
      class="fiche-client-tab"
    >
      <div class="fiche-client-tab__header">
        <div class="fiche-client-tab__header__wrapper">
          <span class="fiche-client-tab__header__bold-text">
            Raison sociale —
          </span>
          {{ raison_sociale }}
        </div>
        <div class="fiche-client-tab__header__wrapper">
          <span class="fiche-client-tab__header__bold-text">
            Code client —
          </span>
          {{  fromStructureLevel().structure.code_client }}
        </div>
      </div>

      <!-- ADRESSE SECTION -->
      <div class="fiche-client-tab__section">

        <!-- SECTION TITLE -->
        <div class="fiche-client-tab__section__title">
          Adresse
          <ui-icon
            name="home"
          />
        </div>
        <!-- SECTION TITLE -->

        <!-- ADRESSE PRINCIPALE SECTION -->

        <div
          v-if="!isEmpty(adresse_principale)"
          class="fiche-client-tab__section__grid-adress"
        >

          <!-- ADRESSE -->
          <div :class="[hasErrorFor('adresse_principale.adresse') ? `form-group--error` : ``]">
            <div class="form-group__label">
              <ui-label for="adresse_principale.adresse" class="form-group__label__required">
                Adresse
              </ui-label>
            </div>
            <div class="form-group__field mb-1">
              <ui-form-input
                v-model="adresse_principale.adresse"
                name="adresse_principale.adresse"
                @keyup="globalCheckingCount > 0 && checkFor('adresse_principale.adresse')"
              />
              <small
                v-if="hasErrorForWith('adresse_principale.adresse', 'presence')"
                class="form-group__error"
              >
                L'adresse est obligatoire
              </small>
              <small
                v-else-if="hasErrorForWith('adresse_principale.adresse', 'length')"
                class="form-group__error"
              >
                L'adresse est trop longue
              </small>
            </div>
          </div>
          <!-- ADRESSE -->

          <!-- COMPLEMENT -->
          <div>
            <div class="form-group__label">
              <ui-label for="adresse_principale.complement_adresse">Complément d'adresse</ui-label>
            </div>
            <div class="form-group__field">
              <ui-form-input
                v-model="adresse_principale.complement_adresse"
                name="adresse_principale.complement_adresse"
              />
            </div>
          </div>
          <!-- COMPLEMENT -->

          <!-- CODE POSTAL -->
          <div :class="[hasErrorFor('adresse_principale.code_postal') ? `form-group--error` : ``]">
            <div class="form-group__label">
              <ui-label for="adresse_principale.code_postal" class="form-group__label__required">
                Code postal
              </ui-label>
            </div>
            <div class="form-group__field mb-1">
              <ui-form-input
                v-model="adresse_principale.code_postal"
                v-mask="masks.adresse_principale.code_postal"
                name="adresse_principale.code_postal"
                @keyup="globalCheckingCount > 0 && checkFor('adresse_principale.code_postal')"
              />
              <small
                v-if="hasErrorFor('adresse_principale.code_postal')"
                class="form-group__error"
              >
                Doit comporter 5 chiffres
              </small>
            </div>
          </div>
          <!-- CODE POSTAL -->

          <!-- VILLE -->
          <div :class="[hasErrorFor('adresse_principale.ville') ? `form-group--error` : ``]">
            <div class="form-group__label">
              <ui-label for="adresse_principale.ville" class="form-group__label__required">
                Ville
              </ui-label>
            </div>
            <div class="form-group__field mb-1">
              <ui-form-input
                v-model="adresse_principale.ville"
                name="adresse_principale.ville"
                @keyup="globalCheckingCount > 0 && checkFor('adresse_principale.ville')"
              />
              <small
                v-if="hasErrorFor('adresse_principale.ville')"
                class="form-group__error"
              >
                La ville est obligatoire
              </small>
            </div>
          </div>
          <!-- VILLE -->

        </div>

        <!-- ADRESSE PRINCIPALE SECTION -->

        <ui-wad :class="{ 'mt-2': true, 'mb-1': hasDifferentFacturationAdresse }">
          <ui-tooltip-wrapper
            class="d-inline-block"
            v-bind="{
              title: `Si vous n'avez pas renseigné l'adresse de facturation, elle sera identique à l'adresse principale`,
            }"
          >
            <div
              class="fiche-client-tab__section__facturation-title"
              @click="hasDifferentFacturationAdresse = !hasDifferentFacturationAdresse"
            >
              Adresse de facturation
              <ui-icon
              class="font-size-140"
                :name="hasDifferentFacturationAdresse ?
                  'expand_less' :
                  'expand_more'
                "
              />
            </div>
          </ui-tooltip-wrapper>
        </ui-wad>

        <!-- ADRESSE DE FACTURATION SECTION -->

        <div
          v-if="hasDifferentFacturationAdresse && adresse_facturation"
          class="fiche-client-tab__section__grid-adress__facturation"
        >

          <!-- ADRESSE -->
          <div :class="[hasErrorFor('adresse_facturation.adresse') ? `form-group--error` : ``]">
            <div class="form-group__label">
              <ui-label for="adresse_facturation.adresse" class="form-group__label__required">
                Adresse
              </ui-label>
            </div>
            <div class="form-group__field mb-1">
              <ui-form-input
                v-model="adresse_facturation.adresse"
                name="adresse_facturation.adresse"
                @keyup="globalCheckingCount > 0 && checkFor('adresse_facturation.adresse')"
              />
              <small
                v-if="hasErrorForWith('adresse_facturation.adresse', 'presence')"
                class="form-group__error"
              >
                L'adresse de facturation est obligatoire
              </small>
              <small
                v-if="hasErrorForWith('adresse_facturation.adresse', 'length')"
                class="form-group__error"
              >
                L'adresse de facturation est trop longue
              </small>
            </div>
          </div>
          <!-- ADRESSE -->

          <!-- COMPLEMENT -->
          <div>
            <div class="form-group__label">
              <ui-label for="adresse_facturation.complement_adresse">Complément d'adresse</ui-label>
            </div>
            <div class="form-group__field">
              <ui-form-input
                v-model="adresse_facturation.complement_adresse"
                name="adresse_facturation.complement_adresse"
              />
            </div>
          </div>
          <!-- COMPLEMENT -->

          <!-- CODE POSTAL -->
          <div :class="[hasErrorFor('adresse_facturation.code_postal') ? `form-group--error` : ``]">
            <div class="form-group__label">
              <ui-label for="adresse_facturation.code_postal" class="form-group__label__required">
                Code postal
              </ui-label>
            </div>
            <div class="form-group__field mb-1">
              <ui-form-input
                v-model="adresse_facturation.code_postal"
                v-mask="masks.adresse_facturation.code_postal"
                name="adresse_facturation.code_postal"
                @keyup="globalCheckingCount > 0 && checkFor('adresse_facturation.code_postal')"
              />
              <small
                v-if="hasErrorFor('adresse_facturation.code_postal')"
                class="form-group__error"
              >
                Doit comporter 5 chiffres
              </small>
            </div>
          </div>
          <!-- CODE POSTAL -->

          <!-- VILLE -->
          <div :class="[hasErrorFor('adresse_facturation.ville') ? `form-group--error` : ``]">
            <div class="form-group__label">
              <ui-label for="adresse_facturation.ville" class="form-group__label__required">
                Ville
              </ui-label>
            </div>
            <div class="form-group__field mb-1">
              <ui-form-input
                v-model="adresse_facturation.ville"
                name="adresse_facturation.ville"
                @keyup="globalCheckingCount > 0 && checkFor('adresse_facturation.ville')"
              />
              <small
                v-if="hasErrorFor('adresse_facturation.ville')"
                class="form-group__error"
              >
                La ville de facturation est obligatoire
              </small>
            </div>
          </div>
          <!-- VILLE -->

        </div>

        <!-- ADRESSE DE FACTURATION SECTION -->

      </div>
      <!-- ADRESSE SECTION -->

      <!-- GESTION DES CONTACTS SI -->
      <div class="fiche-client-tab__section">

        <!-- SECTION TITLE -->
        <div class="fiche-client-tab__section__title">
          Contacts SI
          <ui-icon
            name="person"
          />
        </div>

        <!-- SECTION CONTENTS -->
        <it-contact-block
          :it-contacts-list="listSI"
          :add-row-callback="addSIUser"
          :update-callback="editSIUser"
          :delete-callback="deleteSIUser"
        />
        <!-- SECTION CONTENTS -->

      </div>
      <!-- GESTION DES CONTACTS SI -->

      <!-- ACTIVITE SECTION -->
      <div
        ref="activite_section"
        class="fiche-client-tab__section"
      >

        <!-- SECTION TITLE -->
        <div class="fiche-client-tab__section__title">
          Activité
          <ui-icon
            name="domain"
          />
        </div>
        <!-- SECTION TITLE -->

        <!-- SECTION GRID -->
        <div
          :class="{
            'fiche-client-tab__section__grid-activity': true,
            'fiche-client-tab__section__grid-activity__short': expert_comptable_ou_prestataire
          }"
        >

          <!-- NUMERO DE SIRET -->
          <ui-wad class="w-1" :class="[hasErrorFor('siret') ? `form-group--error` : ``]">
            <div class="form-group__label">
              <ui-label for="siret" class="form-group__label__required">
                Numéro de SIRET
              </ui-label>
            </div>
            <div class="form-group__field mb-1">
              <ui-form-input
                v-model="siret"
                name="siret"
                @keyup="globalCheckingCount > 0 && checkFor('siret')"
              />
              <small
                v-if="hasErrorFor('siret')"
                class="form-group__error"
              >
                Doit comporter 14 chiffres
              </small>
            </div>
          </ui-wad>
          <!-- NUMERO DE SIRET -->

          <!-- CODE APE, LIBELLE APE -->
          <div>
            <div class="form-group__label">
              <ui-label for="code_ape">
                Code APE
              </ui-label>
            </div>
            <ui-wad class="d-flex gap-3">
              <div class="form-group__field mb-1" :class="[hasErrorFor('code_ape') ? `form-group--error` : ``]">
                <ui-form-input
                  v-model="code_ape"
                  v-mask="masks.code_ape"
                  name="code_ape"
                  @keyup="globalCheckingCount > 0 && checkFor('code_ape')"
                />
                <small
                  v-if="hasErrorFor('code_ape')"
                  class="form-group__error"
                >
                  Doit comporter 4 chiffres suivi d'une lettre
                </small>
              </div>
            </ui-wad>
          </div>
          <!-- CODE APE, LIBELLE APE -->

          <!-- SYNDICAT / FÉDÉRATION -->
          <ui-wad class="w-1 d-flex gap-3">
            <ui-wad class="w-1">
              <div class="form-group__label">
                <ui-label for="syndicat_federation">
                  Syndicat / Fédération
                </ui-label>
              </div>
              <ui-wad class="d-flex gap-3">
                <ui-wad class="form-group__field w-1" :class="[hasErrorFor('syndicat_federation') ? `form-group--error` : ``]">
                  <ui-form-tree
                    ref="syndicat_federation_tree"
                    v-model="syndicats"
                    :options="options.syndicats"
                    placeholder="Sélectionnez ou saisissez un ou plusieurs syndicats / fédérations"
                    name="syndicat_federation"
                    clearable
                    searchable
                    flatten-search-results
                    multiple
                    no-result-hidden
                  >
                    <template #before-list="{ search }">
                      <ui-wad
                        v-if="!search"
                        class="form-group__hint"
                      >
                        Votre syndicat / fédération n'est pas dans la liste ? Ecrivez-le afin de l'ajouter
                      </ui-wad>
                    </template>
                    <template #after-list="{ search }">
                      <add-option
                        :search="search"
                        add-text="Ajouter un nouveau syndicat / fédération"
                        :add-custom-option="(option) => addCustomOption('syndicats', option)"
                      />
                    </template>
                  </ui-form-tree>
                </ui-wad>
              </ui-wad>
            </ui-wad>
          </ui-wad>
          <!-- SYNDICAT / FÉDÉRATION -->


          <!-- EXPERT-COMPTABLE / PRESTATAIRE DE PAIE -->
          <ui-wad
            class="w-1 d-flex gap-3"
          >
            <ui-wad class="w-1 cursor-pointer">
              <div class="form-group__label">
                <ui-label for="expert_comptable_ou_prestataire">
                  Expert-comptable / Prestataire de paie
                </ui-label>
              </div>
              <ui-wad class="d-flex gap-3">
                <ui-form-checkbox
                  v-model="expert_comptable_ou_prestataire"
                  switch
                  class="font-weight-light"
                >
                  Je suis un expert-comptable / prestataire de paie
                </ui-form-checkbox>
              </ui-wad>
            </ui-wad>
          </ui-wad>
          <!-- EXPERT-COMPTABLE / PRESTATAIRE DE PAIE -->

          <!-- CHAMP D'ACTIVITE, ACTIVITE PRINCIPALE -->
          <ui-wad
            v-if="!expert_comptable_ou_prestataire"
            class="w-1 d-flex gap-3"
          >
            <ui-wad class="w-1">
              <div class="form-group__label">
                <ui-label for="activité" class="form-group__label__required">
                  Champ d'activité
                </ui-label>
              </div>
              <ui-wad class="d-flex gap-3">
                <ui-wad class="form-group__field w-1" :class="[hasErrorFor('champ_activite') ? `form-group--error` : ``]">
                  <ui-form-inner-icon
                    name="search"
                  >
                    <ui-form-tree
                      v-model="champ_activite"
                      :options="options.champ_activite"
                      placeholder="Champ activité"
                      name="activité"
                      :multiple="false"
                      clearable
                      searchable
                      flatten-search-results
                    />
                  </ui-form-inner-icon>
                </ui-wad>
              </ui-wad>
            </ui-wad>
          </ui-wad>

          <ui-wad
            v-if="!expert_comptable_ou_prestataire"
            class="w-1 d-flex gap-3"
          >
            <ui-wad class="w-1">
              <div class="form-group__label">
                <ui-label for="activité_principale" class="form-group__label__required">
                  Activité principale
                </ui-label>
              </div>
              <ui-wad class="d-flex gap-3">
                <ui-wad class="form-group__field w-1" :class="[hasErrorFor('activite_principale') ? `form-group--error` : ``]">
                  <ui-form-inner-icon
                    name="search"
                  >
                    <ui-form-tree
                      v-model="activite_principale"
                      :status="activitePrincipaleStatus"
                      :options="activitePrincipaleOptions"
                      placeholder="Activité principale"
                      name="activité_principale"
                      :multiple="false"
                      clearable
                      searchable
                      flatten-search-results
                    />
                  </ui-form-inner-icon>
                </ui-wad>
              </ui-wad>
            </ui-wad>
          </ui-wad>
          <!-- CHAMP D'ACTIVITE, ACTIVITE PRINCIPALE -->

        </div>

      </div>
      <!-- ACTIVITE SECTION -->


      <!-- AUTRES LOGICIELS SECTION -->
      <div class="fiche-client-tab__section">

        <!-- SECTION TITLE -->
         <ui-tooltip-wrapper
          class="d-inline-block"
          v-bind="{
            title: 'Indiquez-nous ici les autres logiciels avec lesquel vous travaillez',
          }"
        >
          <div class="fiche-client-tab__section__title">
            Autres logiciels
            <ui-icon
              name="info"
            />
          </div>
        </ui-tooltip-wrapper>
        <!-- SECTION TITLE -->

        <!-- SECTION GRID -->
        <div class="fiche-client-tab__section__grid-other">

          <!-- LOGICIELS DE PLANIFICATION -->
          <div>
            <div class="form-group__label">
              <ui-label for="logiciels_planification">
                Logiciels de planification
              </ui-label>
            </div>
            <div class="form-group__field">
              <ui-form-tree
                ref="logiciels_planification_tree"
                v-model="logiciels_planification"
                :options="options.logiciels_de_planification"
                placeholder="Sélectionnez ou saisissez un ou plusieurs logiciels"
                name="logiciels_planification"
                clearable
                searchable
                flatten-search-results
                multiple
                no-result-hidden
              >
                <template #before-list="{ search }">
                  <ui-wad
                    v-if="!search"
                    class="form-group__hint"
                  >
                    Votre logiciel n'est pas dans la liste ? Ecrivez-le afin de l'ajouter
                  </ui-wad>
                </template>
                <template #after-list="{ search }">
                  <add-option
                    :search="search"
                    :add-custom-option="(option) => addCustomOption('logiciels_de_planification', option)"
                  />
                </template>
              </ui-form-tree>
            </div>
          </div>
          <!-- LOGICIELS DE PLANIFICATION -->

          <!-- LOGICIELS DE GESTION -->
          <div>
            <div class="form-group__label">
              <ui-label for="logiciels_rh">Logiciels de gestion RH</ui-label>
            </div>
            <div class="form-group__field">
              <ui-form-tree
                ref="logiciels_rh_tree"
                v-model="logiciels_rh"
                :options="options.logiciels_de_gestion_rh"
                placeholder="Sélectionnez ou saisissez un ou plusieurs logiciels"
                name="logiciels_rh"
                clearable
                searchable
                flatten-search-results
                multiple
                no-result-hidden
              >
                <template #before-list="{ search }">
                  <ui-wad
                    v-if="!search"
                    class="form-group__hint"
                  >
                    Votre logiciel n'est pas dans la liste ? Ecrivez-le afin de l'ajouter
                  </ui-wad>
                </template>
                <template #after-list="{ search }">
                  <add-option
                    :search="search"
                    :add-custom-option="(option) => addCustomOption('logiciels_de_gestion_rh', option)"
                  />
                </template>
              </ui-form-tree>
            </div>
          </div>
          <!-- LOGICIELS DE GESTION -->

          <!-- LOGICIELS COMPTABLES -->
          <div>
            <div class="form-group__label">
              <ui-label for="logiciels_comptabilite">
                Logiciels de comptabilité
              </ui-label>
            </div>
            <div class="form-group__field">
              <ui-form-tree
                ref="logiciels_comptabilite_tree"
                v-model="logiciels_comptabilite"
                :options="options.logiciels_de_comptabilite"
                placeholder="Sélectionnez ou saisissez un ou plusieurs logiciels"
                name="logiciels_comptabilite"
                clearable
                searchable
                flatten-search-results
                multiple
                no-result-hidden
              >
                <template #before-list="{ search }">
                  <ui-wad
                    v-if="!search"
                    class="form-group__hint"
                  >
                    Votre logiciel n'est pas dans la liste ? Ecrivez-le afin de l'ajouter
                  </ui-wad>
                </template>
                <template #after-list="{ search }">
                  <add-option
                    :search="search"
                    :add-custom-option="(option) => addCustomOption('logiciels_de_comptabilite', option)"
                  />
                </template>
              </ui-form-tree>
            </div>
          </div>
          <!-- LOGICIELS COMPTABLES -->

        </div>

      </div>
      <!-- ACTIVITE SECTION -->
       <ui-wad class="d-flex gap-2 align-items-center justify-content-center">

          <layout-cta-super
            class="fiche-client-tab__save-button"
            component="ui-button"
            :variant="UI.VARIANT.PRIMARY"
            :status="isPending ? UI.STATUS.DEFFERED : UI.STATUS.ENABLED"
            @click="save"
          >
            Enregistrer tout <ui-icon name="save" />
          </layout-cta-super>

          <ui-buffered-pending-icon
            ref="pending"
            class="d-flex align-items-center justify-content-center mt-1"
            :is-pending="false"
            :type="UI.SPINNER_TYPE.BORDER"
            :size="UI.SIZE.LARGE"
          />
      </ui-wad>
    </div>
  </transition>

    </main>
  </div>
</template>

<style lang="sass" scoped>
@import ~/assets/sass/modules/form/members
@import '~/assets/sass/modules/layout/members'

.fiche-societe
  @extend %fit-waterline

  &__main
    @include noised-background
    padding-top: space-x(4)

.fiche-client-tab
  width: 80%
  padding: space-x(2)
  margin-left: auto
  margin-right: auto
  display: flex
  flex-direction: column
  gap: space-x(2)
  position: relative

  &__header
    background-color: mix-alpha($primary, 90%)
    padding: space-x(2)
    display: flex
    color: $white
    justify-content: space-between
    border: solid 1px $primary
    border-radius: $border-radius
    box-shadow: $shadow-cel-shading

    &__wrapper
      font-family: $font-family-monospace
      font-size: 90%

    &__bold-text
      font-family: $font-family-base-condensed
      font-weight: $font-weight-bolder
      text-transform: uppercase

  &__loading,
  &__error
    $loading-placeholder-height: 395px
    display: flex
    min-height: $loading-placeholder-height
    align-items: center
    justify-content: center
    text-align: center
    font-size: 110%
    color: $danger


  &__save-button
    margin-top: space-x(2.5)
    min-width: 20%

  &__add-logiciel
    @include clickable
    display: flex
    align-items: center
    gap: space-x(.5)
    padding: ($card-spacer-y * .5) ($card-spacer-x * .5)
    font-size: 90%
    color: $primary
    font-weight: $font-weight-bold

    &:hover
      background-color: mix-alpha($primary, 5%)

  .form-group

    &__hint
      font-weight: $font-weight-light
      font-size: 85%
      color: $input-placeholder-color

    &__label
      font-family: $font-family-heading
      font-size: 11.5px
      font-weight: $font-weight-bolder
      text-transform: uppercase

      &__required
        position: relative

        &::after
          $offset-x: space-x(0.25)
          $offset-y: space-x(-0.75)

          content: '*'
          color: $color-red
          font-weight: $font-weight-bolder
          font-size: 125%
          transform: translate($offset-x, $offset-y)
          position: absolute
          display: inline-block


  &__section
    padding: space-x(2)
    background: linear-gradient(to bottom, $background-secondary, $background-tertiary)
    border: solid 1px $primary
    border-radius: $border-radius
    box-shadow: $shadow-cel-shading

    &__facturation-title
      @include clickable
      display: flex
      gap: space-x(1)
      font-weight: $font-weight-bolder
      text-transform: uppercase
      align-items: center
      background-color: mix-alpha($primary, 5%)
      padding: space-x(1)
      border-radius: $border-radius
      font-size: 90%

    &__title
      display: flex
      gap: space-x(1)
      font-weight: $font-weight-bolder
      text-transform: uppercase
      margin-bottom: space-x(2)
      align-items: center

      .ui-icon
        font-size: 110%
        margin-bottom: space-x(0.5)

    &__grid-activity
      display: grid
      grid-template-columns: 1fr 1fr
      grid-template-rows: 1fr 1fr 1fr
      gap: space-x(3)

      &__short
        grid-template-rows: 1fr 1fr

      @include media('<laptop')
        grid-template-columns: 1fr

    &__grid-adress
      display: grid
      grid-template-columns: 1fr 1fr
      grid-template-rows: 1fr 1fr
      gap: space-x(3)

      &__facturation
        display: grid
        grid-template-columns: 1fr 1fr
        grid-template-rows: 1fr 1fr
        gap: space-x(3)
        background-color: mix-alpha($primary, 5%)
        padding: space-x(2)
        border-radius: $border-radius

        @include media('<laptop')
          grid-template-columns: 1fr

      @include media('<laptop')
        grid-template-columns: 1fr

    &__grid-other
      display: grid
      grid-template-columns: 1fr 1fr
      grid-template-rows: 1fr 1fr
      gap: space-x(3)

      @include media('<laptop')
        grid-template-columns: 1fr

</style>

<script lang="ts">
import { clone, isEmpty, toString, merge, pipe_, when, any, equals, append, tapCatch, reject, findIndex } from '~/utils/lib/core/prelude'
import { useLegacyPageFetch } from '~/composables/core/hook'
import { useToastBuilder } from '~/composables/layout/toast'
import { CUSTOM_OPTION_PREFIX, useStore_compteClient_base_societe, masks, baseConstraints, constraintsActivite, constraintsAdresseFacturation, type Adresse, type SocieteInfos, type Syndicat } from '~/stores/compte-client/base/societe'
import { MENU_ITEM, NAVIGATION_SCOPE } from '~/utils/lib/layout/types'
import { useDataOnlyNavigationContext } from '~/composables/layout/navigation'
import Console from '~/utils/lib/core/console'
import { useValidation } from '~/composables/core/validation'
import { useLinkHandler } from '~/composables/core/link-handler'
import { useScroll } from '~/composables/layout/scroll'
import type { UITreeOption } from '~/components/ui/form/Tree.vue'
import type { UiBufferedPendingIcon, UiFormTree } from '#components'
import AddOption, { ERRORS } from '~/components/compte-client/AddOption.vue'
import { useStore_compteClient_base_contacts, type SiContact } from '~/stores/compte-client/base/contacts'
import { useStore_compteClient_client_contacts_list } from '~/stores/compte-client/client/contacts/list'
import ItContactBlock from '~/components/compte-client/ItContactBlock.vue'

const console = new Console('component:compte-client:fiche-societe')

export default defineNuxtComponent({
  components: {
    AddOption,
    ItContactBlock,
  },
  setup() {
    definePageMeta({
      navigationScope: NAVIGATION_SCOPE.DATA_ONLY,
      menuItem: MENU_ITEM.PARAMETERS_GENERAL,
    })

    const navigationContext = useDataOnlyNavigationContext()

    useHead({
      title: 'Fiche client'
    })

    const {
      fetchState,
      fetchWrapper,
    } = useLegacyPageFetch()

    const {
      scrollTo
    } = useScroll()

    const ref_pending
      = useTemplateRef<InstanceType<typeof UiBufferedPendingIcon>>('pending')

    const ref_syndicat_federation_tree = useTemplateRef<InstanceType<typeof UiFormTree>>('syndicat_federation_tree')
    const ref_logiciels_planification_tree = useTemplateRef<InstanceType<typeof UiFormTree>>('logiciels_planification_tree')
    const ref_logiciels_rh_tree = useTemplateRef<InstanceType<typeof UiFormTree>>('logiciels_rh_tree')
    const ref_logiciels_comptabilite_tree = useTemplateRef<InstanceType<typeof UiFormTree>>('logiciels_comptabilite_tree')

    const ToastBuilder = useToastBuilder()

    const store_base_societe = useStore_compteClient_base_societe()
    const store_base_contacts = useStore_compteClient_base_contacts()
    const store_client_contacts_list = useStore_compteClient_client_contacts_list()

    return {
      ...useLinkHandler(),
      ...navigationContext,
      fetchState,
      fetchWrapper,
      ToastBuilder,
      ...useValidation(baseConstraints),
      store_base_societe,
      store_base_contacts,
      store_client_contacts_list,
      ref_pending,
      ref_logiciels_planification_tree,
      ref_syndicat_federation_tree,
      ref_logiciels_rh_tree,
      ref_logiciels_comptabilite_tree,
      scrollTo,
    }
  },
  data() {
    return {
      masks,
      isEmpty,
      isPending: false,

      /* ===== FORM VALUES =====  */

      /* BLOC ADRESSE */
        adresse_principale: null as unknown as Adresse,
        hasDifferentFacturationAdresse: false,
        adresse_facturation: null as unknown as Adresse|null,
      /* ADRESSE */

      /* BLOC ACTIVITE */
        code_ape: '',
        adherent_syndicat: false,
        syndicats: [] as Syndicat['type'][],
        siret: '',
        champ_activite: '',
        activite_principale: '',
        site_web: '',
        raison_sociale: '',
      /* BLOC ACTIVITE */

      /* BLOC AUTRES LOGICIELS */
        logiciels_planification: [] as SocieteInfos["logiciels_de_planification"],
        logiciels_planification_search: '',
        logiciels_rh: [] as SocieteInfos["logiciels_de_gestion_rh"],
        logiciels_comptabilite: [] as SocieteInfos["logiciels_de_comptabilite"],
        expert_comptable_ou_prestataire: false,
      /* BLOC AUTRES LOGICIELS */

      /* BLOC OPTIONS */
        options: {
          logiciels_de_planification: [] as UITreeOption[],
          logiciels_de_gestion_rh: [] as UITreeOption[],
          logiciels_de_comptabilite: [] as UITreeOption[],
          syndicats: [] as UITreeOption[],
          champ_activite: [] as UITreeOption[],
          activites: {} as Record<SocieteInfos["champ_activite"], UITreeOption[]>,
        },
      /* BLOC OPTIONS */

      listSI: [] as SiContact[], // lazy

      /* ===== FORM VALUES ===== */
    }
  },
  computed: {
    activitePrincipaleStatus() {
      if (isEmpty(this.champ_activite)) return this.UI.STATUS.DISABLED
      return this.UI.STATUS.ENABLED
    },
    activitePrincipaleOptions() {
      if (!this.champ_activite) return []
      return this.options.activites[this.champ_activite] || []
    },
  },
  created() {
    this.fetchWrapper(
      () => this.fetch()
      .then(() => {
        // delayed watcher for activite_principale
        this.$watch('champ_activite', () => {
          this.activite_principale = null as unknown as string
        })

        // delayed watcher for hasDifferentFacturationAdresse
        this.$watch('hasDifferentFacturationAdresse', (val) => {
          this.updateConstraints()
          if (val) {
            this.adresse_facturation = clone(this.adresse_principale)
          }
        })

        // delayed watcher for expert_comptable_ou_prestataire
        this.$watch('expert_comptable_ou_prestataire', () => {
          this.updateConstraints()
        })
      })
    )
  },
  methods: {
    updateConstraints() {
      this.constraints = pipe_(
        clone(baseConstraints),
        when(
          () => this.hasDifferentFacturationAdresse,
          merge(constraintsAdresseFacturation)
        ),
        when(
          () => !this.expert_comptable_ou_prestataire,
          merge(constraintsActivite)
        )
      )
    },
    addCustomOption(category: string, option: string) {

      if (isEmpty(option) ||
          isEmpty(option.trim()) ||
          equals(option, CUSTOM_OPTION_PREFIX)
      ) {
        throw new Error(ERRORS.ON_OPTION_ADDED_ERROR)
      }

      switch (category) {

        case 'logiciels_de_planification':
          if (any(
            (opt) => equals(opt.value, `${CUSTOM_OPTION_PREFIX} ${option}`),
            this.options.logiciels_de_planification
          )) {
            throw new Error(ERRORS.ON_OPTION_ADDED_ERROR)
          }

          this.options.logiciels_de_planification.push({
            value: `${CUSTOM_OPTION_PREFIX} ${option}`,
            text: `${CUSTOM_OPTION_PREFIX} ${option}`,
          })

          this.logiciels_planification = [
            ...this.logiciels_planification,
            `${CUSTOM_OPTION_PREFIX} ${option}`
          ]

          this.ref_logiciels_planification_tree?.blur()

          break

        case 'logiciels_de_gestion_rh':
          if (any(
            (opt) => equals(opt.value, `${CUSTOM_OPTION_PREFIX} ${option}`),
            this.options.logiciels_de_gestion_rh
          )) {
            throw new Error(ERRORS.ON_OPTION_ADDED_ERROR)
          }

          this.options.logiciels_de_gestion_rh.push({
            value: `${CUSTOM_OPTION_PREFIX} ${option}`,
            text: `${CUSTOM_OPTION_PREFIX} ${option}`,
          })

          this.logiciels_rh = [
            ...this.logiciels_rh,
            `${CUSTOM_OPTION_PREFIX} ${option}`
          ]

          this.ref_logiciels_rh_tree?.blur()
          break

        case 'logiciels_de_comptabilite':
          if (any(
            (opt) => equals(opt.value, `${CUSTOM_OPTION_PREFIX} ${option}`),
            this.options.logiciels_de_comptabilite
          )) {
            throw new Error(ERRORS.ON_OPTION_ADDED_ERROR)
          }

          this.options.logiciels_de_comptabilite.push({
            value: `${CUSTOM_OPTION_PREFIX} ${option}`,
            text: `${CUSTOM_OPTION_PREFIX} ${option}`,
          })

          this.logiciels_comptabilite = [
            ...this.logiciels_comptabilite,
            `${CUSTOM_OPTION_PREFIX} ${option}`
          ]

          this.ref_logiciels_comptabilite_tree?.blur()
          break

        case 'syndicats':
          if (any(
            (opt) => equals(opt.value, `${CUSTOM_OPTION_PREFIX} ${option}`),
            this.options.syndicats
          )) {
            throw new Error(ERRORS.ON_OPTION_ADDED_ERROR)
          }

          this.options.syndicats.push({
            value: `${CUSTOM_OPTION_PREFIX} ${option}`,
            text: `${CUSTOM_OPTION_PREFIX} ${option}`,
          })

          this.syndicats = [
            ...this.syndicats,
            `${CUSTOM_OPTION_PREFIX} ${option}`
          ]

          this.ref_syndicat_federation_tree?.blur()
          break
      }
    },
    addSIUser(values) {
      const options = {
        code_client: this.fromStructureLevel().structure.code_client,
      }

      const values_ = {
        ...values,
        si: true,
      }

      return this.store_base_contacts.create({ ...options, infos: values_ })
        .then(res => {
          this.listSI = append(
            res,
            this.listSI
          )
        })
        .catch(tapCatch((err: any) => {
          console.warn('création de contact SI', err)
          this.ToastBuilder
            .error(toString(err))
            .title(`Mise à jour de contact SI`)
            .show()
        }))
    },
    editSIUser(values) {
      const options = {
        code_client: this.fromStructureLevel().structure.code_client,
      }

      return this.store_base_contacts.edit({ ...options, infos: values })
        .then(res => {
          const contactIndex = findIndex(({ k_contact }) => k_contact === res.k_contact, this.listSI)

          if (contactIndex === -1) return

          const contacts = clone(this.listSI)

          contacts[contactIndex] = res

          this.listSI = contacts
        })
        .catch((err: any) => {
          console.warn('mise à jour de contact SI', err)
          this.ToastBuilder
            .error(toString(err))
            .title(`Mise à jour de contact SI`)
            .show()
        })
    },
    deleteSIUser(kContact) {
      const options = {
        code_client: this.fromStructureLevel().structure.code_client,
      }

      return this.store_base_contacts.delete({ ...options, kContact })
        .then(() => {

          this.listSI = reject(
            contact => contact.k_contact === kContact,
            this.listSI
          )
        })
        .catch(err => {
          console.warn('suppression de contact SI', err)
          this.ToastBuilder
            .error(toString(err))
            .title(`Suppression de contact SI`)
            .show()
        })
    },
    save() {
      this.checkAll()

      if (this.hasError()) {
        this.scrollTo('.form-group--error')
        return
      }

      this.isPending = true

      const {
        structure: { code_client },
      } = this.fromStructureLevel()

      const data = {
        adresse_principale: this.adresse_principale,
        adresse_facturation_identique: !this.hasDifferentFacturationAdresse,
        adresse_facturation: this.adresse_facturation,
        code_ape: this.code_ape,
        adherent_syndicat: this.adherent_syndicat,
        syndicats: this.syndicats,
        siret: this.siret,
        raison_sociale: this.raison_sociale,
        logiciels_de_planification: this.logiciels_planification,
        logiciels_de_gestion_rh: this.logiciels_rh,
        logiciels_de_comptabilite: this.logiciels_comptabilite,
        expert_comptable_ou_prestataire: this.expert_comptable_ou_prestataire,
        champ_activite: this.champ_activite,
        activite_principale: this.activite_principale,
      }

      const options = {
        code_client,
        data,
      }

      return this.store_base_societe.edit(options)
      .then(() => {
        this.isPending = false
        this.ref_pending?.onSuccess()
      })
      .catch((err) => {
        this.ref_pending?.onError()
        this.isPending = false
        console.warn('save', err)
        return this.ToastBuilder
          .error(toString(err))
          .title(`Erreur lors de l'enregistrement des changements`)
          .show()
      })
    },
    fetch() {
      const {
        structure: { code_client },
      } = this.fromStructureLevel()

      const options = {
        code_client,
      }

      return Promise.all([
        this.store_base_societe.infos(options),
        this.store_base_societe.options(options),
        this.store_client_contacts_list.exec(options)
      ])
      .then(([societeInfos, options, { listSI }]) => {
        // Other data
        this.raison_sociale = societeInfos.raison_sociale

        // Adresse bloc
        this.adresse_principale = societeInfos.adresse_principale
        this.adresse_facturation = societeInfos.adresse_facturation
        this.hasDifferentFacturationAdresse = !societeInfos.adresse_facturation_identique

        // Activite bloc
        this.siret = societeInfos.siret
        this.code_ape = societeInfos.code_ape
        this.champ_activite = societeInfos.champ_activite
        this.activite_principale = societeInfos.activite_principale
        this.syndicats = societeInfos.syndicats
        this.expert_comptable_ou_prestataire = societeInfos.expert_comptable_ou_prestataire

        // Autres logiciels
        this.logiciels_planification = societeInfos.logiciels_de_planification
        this.logiciels_rh = societeInfos.logiciels_de_gestion_rh
        this.logiciels_comptabilite = societeInfos.logiciels_de_comptabilite

        this.options = options
        this.listSI = listSI
      })
      .catch((err) => {
        console.warn('fetch', err)
        return this.ToastBuilder
          .error(toString(err))
          .title(`Erreur lors de la récupération des informations`)
          .show()
      })
    }
  }
})
</script>
